import styled from 'styled-components'

import { theme } from 'styles/theme'

// A round icon button, used for actions on a table row. Put the icon as its child and the action name in `title`.
export const RowActionButton = styled.button.attrs({ type: 'button' })`
  display: flex;
  align-items: center;
  justify-content: center;
  // Fixed square size that never shrinks or stretches, so it stays a circle
  flex: none;
  inline-size: 40px;
  block-size: 40px;
  min-inline-size: 40px;
  aspect-ratio: 1;
  padding: 0;
  border: none;
  border-radius: 50%;
  background-color: ${theme.colors.MediumGrey};
  cursor: pointer;
  // Only animate the hover darkening (the global button transition would also delay hiding the button)
  transition: filter ${theme.transitions.normal} ease-out;
  :hover {
    filter: brightness(0.92);
  }
`
